export default __webpack_public_path__ + "static/media/icons8-docker.a2eecd96.svg";